module.exports = __webpack_public_path__ + "static/media/PhoneBlue.d367330f.svg";